module.exports = __webpack_public_path__ + "img/house-2.ed12ff11.jpeg";